import * as React from 'react';
import { RetailerTranslations } from '../../../__generated__/loma';

interface TranslationsProviderValue {
  translations: RetailerTranslations;
}

interface TranslationsProviderProps {
  value: TranslationsProviderValue;
}

const TranslationsContext = React.createContext<TranslationsProviderValue>({
  translations: {},
});

export const TranslationsProvider: React.FC<
  React.PropsWithChildren<TranslationsProviderProps>
> = ({ children, value: { translations } }) => (
  <TranslationsContext.Provider value={{ translations }}>
    {children}
  </TranslationsContext.Provider>
);

export const useTranslations = () => {
  const context = React.useContext(TranslationsContext);
  if (!context) {
    throw new Error('useTranslations was called without a TranslationsContext');
  }
  return context.translations;
};
